const root = window.location.origin;
export const environment = {
  production: true,
  useGdrive: false,
  useGoogle: false,
  baseurl: `${root}/Services/api`,
  title: 'Foerch',
  externalLogin: false,
  root:root
};

export function getrelativeurl(file:string){
  
  return `${root}/${file}`;
}